import { render, staticRenderFns } from "./segmentExportScriptHistoryTable.vue?vue&type=template&id=930d3c68&scoped=true&"
import script from "./segmentExportScriptHistoryTable.vue?vue&type=script&lang=js&"
export * from "./segmentExportScriptHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./segmentExportScriptHistoryTable.vue?vue&type=style&index=0&id=930d3c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930d3c68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VChip,VDataTable})
